import { alpha, Theme } from '@mui/material';

export default {
    wrapper: {
        '.rs-table-row': {
            cursor: 'default',
        },
    },
    previewContainer: {
        position: 'relative',
        minHeight: '34px',
        height: '50px',
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        background: (theme: Theme) =>
            `repeating-linear-gradient(133deg, transparent, transparent 1px, ${alpha(
                theme.palette.text.primary,
                0.02,
            )} 1px, ${alpha(theme.palette.text.primary, 0.02)} 2px)`,
        backgroundColor: 'background.default',
        backgroundSize: '3px 3px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        overflow: 'hidden',
        mb: 2,
        img: {
            maxWidth: 1,
        },
        transition: 'height 400ms ease 0s',
    },
};
